import { __read } from "tslib";
import * as u from './urx';
import { listStateSystem } from './listStateSystem';
export var topItemCountSystem = u.system(function (_a) {
    var _b = __read(_a, 1), topItemsIndexes = _b[0].topItemsIndexes;
    var topItemCount = u.statefulStream(0);
    u.connect(u.pipe(topItemCount, u.filter(function (length) { return length > 0; }), u.map(function (length) { return Array.from({ length: length }).map(function (_, index) { return index; }); })), topItemsIndexes);
    return { topItemCount: topItemCount };
}, u.tup(listStateSystem));
